const en = {
  ListPage: {
    count: " items found",
  },
  Main: {
    photoButtons: {
      image1: "Photo 1",
      imageTitle1: 'Switch ring image to "Photo 1"',
      image2: "2",
      imageTitle2: 'Switch ring image to "Photo 2"',
      image3: "3",
      imageTitle3: 'Switch ring image to "Photo 3"',
      worn: "Worn",
      wornTitle: "See rings being worn",
    },
  },
  RingQuickView: {
    ec_flag: "",
    ec_try_flag: "",
    arluis_limited: "",
    show: "See More",
    blog: "See arrangement results of this ring",
  },
  RingCategoryNav: {
    engagementRings: "Engagement Rings",
    marriageRings: "Wedding Rings",
    setRings: "Set Rings",
  },
  RingItem: {
    urlTitle: "See more details of {ringName}",
  },
  FilterAccordion: {
    clear: "Clear Filters",
    favoritedRings: "#Favorited Rings",
    filterHeader: "Filter Rings",
    filterHeaderTitle: "Filter by Ring Features",
  },
  FilterList: {
    listTitle: {
      design: "Design",
      bullion: "Bullion",
      forged: "Forged Rings",
      texture: "Texture",
      diamond: "Diamond",
      type: "Type",
      ec: "Online Store",
    },
  },
}
const ja = {
  ListPage: {
    count: "件",
  },
  Main: {
    photoButtons: {
      image1: "画像1",
      imageTitle1: "商品画像を「画像1」に切り替える",
      image2: "画像2",
      imageTitle2: "商品画像を「画像2」に切り替える",
      image3: "画像3",
      imageTitle3: "商品画像を「画像3」に切り替える",
      worn: "着用",
      wornTitle: "商品画像を「着用写真」に切り替える",
    },
  },
  RingQuickView: {
    ec_flag: "オンラインストア対応",
    ec_try_flag: "オンライン試着可能",
    arluis_limited: "アールイズコラボ限定リング",
    show: "このリングを詳しく見る",
    blog: "このリングのアレンジ実績を見る",
  },
  RingCategoryNav: {
    engagementRings: "婚約指輪",
    marriageRings: "結婚指輪",
    setRings: "セットリング",
  },
  RingItem: {
    urlTitle: "{ringName}の詳細ページへ移動する",
  },
  FilterAccordion: {
    clear: "絞り込みを解除する",
    favoritedRings: "#お気に入りリング",
    filterHeader: "絞り込み",
    filterHeaderTitle: "指輪の特徴から絞り込む",
  },
  FilterList: {
    listTitle: {
      design: "デザイン",
      bullion: "地金",
      forged: "鍛造",
      texture: "テクスチャ",
      diamond: "ダイヤモンド",
      type: "タイプ",
      ec: "オンラインストア",
    },
  },
}
export const locale = { en, ja }
